import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WaterDropIcon(props: IconProps) {
    return <Icon {...props} iconKey={"water_drop"}/>
}
